const FlashElement = document.getElementById('flash');
if (FlashElement) {
  const tagManagerValue = FlashElement.dataset.tagManager;

  if (tagManagerValue !== undefined) {
    dataLayer.push({'event': tagManagerValue});
  }

  FlashElement.addEventListener('animationend', function() {
    this.parentNode.removeChild(this);
  }, false);

  setTimeout(function() {
    FlashElement.classList.add('animated');
    FlashElement.classList.add('fadeOutUp');
  }, 10000);
}
